// extracted by mini-css-extract-plugin
module.exports = {"rootWrapper":"lFPCA","contentWrapper":"_2GXjK","isSidebar":"_2O27Q","collapsed":"daoiJ"};